export const STD_LOYALTY_FLEX_TARIFFS = { bucket: 'B01' };
export const SP_LOYALTY_FLEX_TARIFFS = { bucket: 'H01' };

export const loyaltyFlexTariffCodes = {
  B: STD_LOYALTY_FLEX_TARIFFS,
  H: SP_LOYALTY_FLEX_TARIFFS
};

export const DIRECTIONS = {
  OUTBOUND: 'outbound',
  INBOUND: 'inbound'
};
